import Swiper from 'swiper';
import { Navigation, Mousewheel } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import contentSelect from './select-content';

gsap.registerPlugin(ScrollToPlugin);

Swiper.use([Navigation, Mousewheel]);

const DOM = {
    sliders: document.querySelectorAll('.js-dial-slider'),
};

const setupSwitcher = () => {
    const btns = document.querySelectorAll('.js-dial-btn');
    btns.forEach((btn) => {
        btn.addEventListener('click', () => {
            contentSelect(btn.dataset.category);
        });
    });

    // scroll to recipes
    const scrollToBtns = document.querySelectorAll('.js-dial-scrollto');
    if (scrollToBtns.length > 0) {
        scrollToBtns.forEach((scrollToBtn) => {
            scrollToBtn.addEventListener('click', () => {
                gsap.to(window, {
                    duration: 1,
                    scrollTo: '.js-dial-scroll-target',
                });
            });
        });
    }
};

const setupSlider = () => {
    DOM.sliders.forEach((slider) => {
        const swiper = new Swiper(slider, { // eslint-disable-line no-unused-vars
            centeredSlides: true,
            watchOverflow: true,
            direction: 'vertical',
            spaceBetween: 10,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            freeMode: true,
            loop: true,
            initialSlide: [...slider.querySelectorAll('.swiper-slide')].findIndex((el) => (
                el.classList.contains('is-selected')
            )),
            breakpoints: {
                0: {
                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 5,
                },
                1200: {
                    slidesPerView: 7,
                },
            },
        });
    });
};

const init = () => {
    if (DOM.sliders.length === 0) return;

    setupSlider();
    setupSwitcher();
};

export default init;
